import _ from 'lodash';
import React from 'react';

import { TraceTreeNode } from '../TraceTree';

import { fromAnyValue } from './otlpHelpers';

const TraceNodeAttributeValue = ({ value }: { value: string }) => {
  let displayValue;
  try {
    const jsonValue = fromAnyValue(JSON.parse(value));
    switch (typeof jsonValue) {
      case 'string':
        displayValue = jsonValue || `""`;
        break;
      case 'number':
        displayValue = jsonValue;
        break;
      default:
        displayValue = JSON.stringify(jsonValue);
        break;
    }
  } catch {
    displayValue = '[unsupported value]';
  }
  return <span title={displayValue.toLocaleString()}>{displayValue}</span>;
};

const TraceNodeAttribute = ({
  attrKey,
  attrValue,
}: {
  attrKey: string;
  attrValue: string;
}) => (
  <div className="flex min-w-0">
    <span className="text-title text-nowrap pr-3">{attrKey}</span>
    <span className="truncate text-secondary">
      <TraceNodeAttributeValue value={attrValue} />
    </span>
  </div>
);

const attributeKeyMap = new Map<string, string>([
  ['graphql.operation.name', 'Operation Name'],
  ['graphql.operation.type', 'Operation Type'],
]);

const defaultKeyTransform = (key: string) => {
  if (attributeKeyMap.has(key)) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return attributeKeyMap.get(key)!;
  }
  const parts = key.split(/[\._]/);
  if (parts[0] === 'apollo') {
    parts.shift();
  }
  return parts.map((part) => _.capitalize(part)).join(' ');
};

export const TraceNodeAttributes = ({
  node,
  transformKey = defaultKeyTransform,
}: {
  node: TraceTreeNode;
  transformKey?: (key: string) => string;
}) => (
  <div className="mt-2">
    {_.orderBy(
      node.attributes.map(({ key, value }) => ({
        key: transformKey(key),
        value,
      })),
      'key',
    ).map(({ key, value }) => (
      <TraceNodeAttribute key={`attr-${key}`} attrKey={key} attrValue={value} />
    ))}
  </div>
);
